import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, filter, map, tap, withLatestFrom } from 'rxjs/operators';
import * as AppSelectors from '../state/app/app.selectors';
import { AppSettingsDto } from './api.services';
import { MatDateFormats } from '@angular/material/core';
import { DateFormatType, getMomentDateFormats } from '../shared/utils/moment';

@Injectable({
  providedIn: 'root',
  deps: [Store]
})
export class AppSettingsService {
  settings$: Observable<AppSettingsDto>;
  locale$ = new ReplaySubject<string>(1);

  // moment formats are used as given, so we create initial instances, then update them (instead of replacing them)
  // this way moment will pick up on format changes after locale is loaded
  momentFormats = <Record<DateFormatType, MatDateFormats>>{};

  constructor(private store: Store) {
    for (let typeName of Object.keys(DateFormatType)) {
      let dateFormatType = DateFormatType[typeName];
      this.momentFormats[dateFormatType] = getMomentDateFormats('en-US', dateFormatType);
    }

    this.settings$ = this.store.select(AppSelectors.getSettings);

    this.settings$.pipe(
      filter(s => !s),
      distinctUntilChanged(),
      tap(({ locale }) => this.locale$.next(locale))
    ).subscribe();

    this.locale$.subscribe(l => {
      this.updateMomentFormats(l);
    });
  }

  private updateMomentFormats(locale: string) {
    for (let typeName of Object.keys(DateFormatType)) {
      let dateFormatType = DateFormatType[typeName];
      let newFormats = getMomentDateFormats(locale, dateFormatType);
      let momentFormats = (this.momentFormats[dateFormatType] ??= {});
      momentFormats.parse = newFormats.parse;
      momentFormats.display = newFormats.display;
    }
  }
}
